var _circle, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXpnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "url(#paint0_linear_2517_13223)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2517_13223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9408 16.7156L11.6443 15.4191C11.2761 15.0508 10.6807 15.0508 10.3164 15.4191L9.01992 16.7156C8.63996 17.0956 8.02108 17.0956 7.64113 16.7156L7.0144 16.0889L9.00033 14.1029C10.0932 13.01 11.8637 13.01 12.9565 14.1029L14.9424 16.0889L14.3157 16.7156C13.9397 17.0956 13.3247 17.0956 12.9408 16.7156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90167 14.9714L5.27495 14.3446C4.895 13.9647 4.895 13.3457 5.27495 12.9658L6.57148 11.6692C6.93968 11.301 6.93968 10.7056 6.57148 10.3413L5.27495 9.04467C4.895 8.6647 4.895 8.04578 5.27495 7.66581L5.90167 7.03906L7.8876 9.02508C8.98045 10.118 8.98045 11.8885 7.8876 12.9814L5.90167 14.9714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9976 8.71643C10.2808 8.71643 9.56396 8.44615 9.01949 7.89774L7.03357 5.91173L7.66029 5.28498C8.04024 4.90501 8.65913 4.90501 9.03908 5.28498L10.3356 6.58157C10.6999 6.94586 11.2992 6.94586 11.6635 6.58157L12.96 5.28498C13.34 4.90501 13.9588 4.90501 14.3388 5.28498L14.9655 5.91173L12.9796 7.89774C12.4312 8.43831 11.7144 8.71643 10.9976 8.71643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.078 14.9557L14.0921 12.9697C12.9992 11.8768 12.9992 10.1063 14.0921 9.01336L16.078 7.02734L16.7047 7.65409C17.0847 8.03406 17.0847 8.65298 16.7047 9.03295L15.4082 10.3295C15.04 10.6978 15.04 11.2932 15.4082 11.6575L16.7047 12.9541C17.0847 13.334 17.0847 13.9529 16.7047 14.3329L16.078 14.9557Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2517_13223",
    x1: 7.48649,
    y1: 3.7027,
    x2: 35.3243,
    y2: -11.4324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E22440"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2517_13223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpnet);
export default __webpack_public_path__ + "static/media/XPNET.b578873eda2ec3749db14d49207d7b3a.svg";
export { ForwardRef as ReactComponent };